// Warmth math, decoupled from UI. v1 cuts the visible status tiers but keeps
// the underlying warmth so chat and stories can still react to it.

import type { Relationship } from './types';

export const DEFAULT_RELATIONSHIP: Relationship = {
  matched: false,
  warmth: 0,
  daysSince: 0,
  lastSeen: 'never',
};

/** Bump warmth by `n`, clamped to [0, 100]. */
export function bumpWarmth(rel: Relationship, n: number): Relationship {
  const warmth = Math.max(0, Math.min(100, rel.warmth + n));
  return { ...rel, warmth };
}

/** Record that the user just messaged this persona. */
export function noteMessageSent(rel: Relationship): Relationship {
  return {
    ...rel,
    daysSince: 0,
    lastSeen: 'just now',
    warmth: Math.min(100, rel.warmth + 2),
  };
}

/** Move time forward by `days`, decaying warmth slightly. */
export function passDays(rel: Relationship, days: number): Relationship {
  if (days <= 0) return rel;
  const warmth = Math.max(0, rel.warmth - days * 4);
  return {
    ...rel,
    daysSince: rel.daysSince + days,
    warmth,
    lastSeen: `${rel.daysSince + days}d ago`,
  };
}
